export class StoreHelper {
  static state(data) {
    return {
      data: data,
      status: {
        pending: false,
        success: false,
        fail: false,
        error: null
      }
    }
  }

  static updateState(state, data = null) {
    if (data === null) {
      // PENDING
      return this._mutationPending({ ...state });
    }
    //SUCCESS or FAIL
    return data instanceof Error
      ? this._mutationFail({ ...state }, data)
      : this._mutationSuccess({ ...state }, data);
  }

  static _mutationPending(state) {
    state.status.pending = true;
    state.status.success = false;
    state.status.fail = false;
    state.status.error = null;
    return state;
  }

  static _mutationSuccess(state, data) {
    state.data = data;
    state.status.pending = false;
    state.status.success = true;
    state.status.fail = false;
    state.status.error = null;
    return state;
  }

  static _mutationFail(state, error) {
    state.status.pending = false;
    state.status.success = false;
    state.status.fail = true;
    state.status.error = error && error.message;
    return state;
  }
}